import { ButtonHTMLAttributes } from "react"

const RejectButton = (props: ButtonHTMLAttributes<HTMLButtonElement>) => {
  return <button className="reject-button" type="button"  {...props}/> 
}

export default RejectButton